// extracted by mini-css-extract-plugin
module.exports = {"profile_page":"style_profile_page__1zu-c","form_container":"style_form_container__3kDxc","form":"style_form__24Yba","img_selector":"style_img_selector__bGlSs"};